import PageState from '../pageState';

export default (pages: PageState[]) => {
  for (const page of pages) {
    for (const control of page.controls) {
      if (control.building) {
        return true;
      }
    }
  }
  return false;
};
